import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import './index.css'
import './lib/logger'
import { isChunkLoadError, reloadOnceForChunkError } from './lib/lazyWithRetry'

// enabled: false quando VITE_SENTRY_DSN não está definido (ex: dev sem .env configurado)
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
  ],
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error }) => <CrashFallback error={error} />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)

function CrashFallback({ error }: { error: unknown }) {
  const isChunkError = isChunkLoadError(error)

  useEffect(() => {
    if (isChunkError) reloadOnceForChunkError()
  }, [isChunkError])

  return (
    <div style={{
      minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#070910', fontFamily: 'system-ui, sans-serif', padding: 24,
    }}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <p style={{ fontSize: 32, marginBottom: 12 }}>{isChunkError ? '🔄' : '⚠️'}</p>
        <h1 style={{ color: '#e2e4f0', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
          {isChunkError ? 'Atualizando...' : 'Algo deu errado'}
        </h1>
        <p style={{ color: '#8b90c8', fontSize: 14, marginBottom: 24 }}>
          {isChunkError
            ? 'Uma nova versão foi publicada. Estamos recarregando.'
            : 'O erro foi registrado automaticamente. Tente recarregar a página.'}
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: '#6366f1', color: '#fff', border: 'none', borderRadius: 12,
            padding: '12px 24px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
          }}
        >
          Recarregar
        </button>
      </div>
    </div>
  )
}
